var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvantage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18_2033",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18_2033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.55884 15.8897L18.7057 6.74278L19.4016 7.4386L9.55 17.2902L4.59843 12.3386L5.29425 11.6428L9.54116 15.8897L9.55 15.8985L9.55884 15.8897Z",
    fill: "#006633",
    stroke: "#006633",
    strokeWidth: 0.025
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvantage);
export default __webpack_public_path__ + "static/media/advantage.b3843796f1e5fcf766e30334a73ee3a7.svg";
export { ForwardRef as ReactComponent };